<template>
  <div class="review choice">
    <div class="review-type-tab" v-if="$route.query.mode === 'review'">
      <p></p>
      <span :class="{ on: _reviewType === 1 }" @click="_reviewType = 1">我的答案</span>
      <span :class="{ on: _reviewType === 2 }" @click="_reviewType = 2">正确答案</span>
    </div>
    <div class="answer-content">
      <div>
        <p class="ques-title">{{ question.questionStem }}</p>
        <CheckboxGroup v-model="answerSelect" class="vertical">
          <Checkbox :label="item.value" v-for="(item, index) in options" :key="index" :disabled="isReview">
            <span>{{ ABC_Order.get(index) }}: {{ item.label }} </span>
          </Checkbox>
        </CheckboxGroup>
      </div>
    </div>
  </div>
</template>

<script>
import { Checkbox, CheckboxGroup } from 'view-design'
import { ABC_Order } from '@/config'
export default {
  components: {
    Checkbox,
    CheckboxGroup
  },
  props: {
    question: {
      type: Object,
      default: () => {}
    },
    answer: {
      type: String,
      required: true
    },
    // 1-我的答案，2-正确答案
    reviewType: {
      type: Number,
      default: 1
    },
    // 顺序
    optionsOrder: {
      type: Array,
      default: () => []
    },
    // 是否随机顺序
    optionsRandom: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      ABC_Order,
      options: []
    }
  },
  computed: {
    answerSelect: {
      get() {
        if (this.answer) {
          const answerObj = JSON.parse(this.answer)
          return answerObj
        }
        return []
      },
      set(val) {
        if (this.isReview) return
        this.$emit('update:answer', JSON.stringify(val))
      }
    },
    // 回顾试卷类型
    _reviewType: {
      get() {
        return this.reviewType
      },
      set(val) {
        this.$emit('update:reviewType', val)
      }
    },
    // 是否是回顾试卷
    isReview() {
      return this.$route.query.mode === 'review'
    }
  },
  created() {
    let arr = JSON.parse(JSON.stringify(this.question.options))
    arr = arr.map((item, index) => {
      return {
        ...item,
        index
      }
    })
    // 随机顺序
    if (this.optionsRandom === 1) {
      arr.sort((prev, next) => {
        return this.optionsOrder.indexOf(prev.index) - this.optionsOrder.indexOf(next.index)
      })
    }
    this.options = arr
  }
}
</script>

<style lang="scss" scoped>
.review {
  .answer-content {
    height: 560px;
    display: flex;
    padding: 60px 100px;
    .ques-title {
      margin-bottom: 30px;
      font-weight: bold;
    }
    .ivu-checkbox-group {
      max-width: 100%;
    }
  }
}
</style>
